export default {
  language: 'cn',
  showNavPanel: false
}